import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import ImageUpload from '../../utils/ImageUpload';
import { editModules, getModules } from '../../feature/modules/moduleSlice';
import { editRelationType, getRelationType } from '../../feature/relation/RelationTypeSlice';



function EditRelationType({ editData }) {
    const { relationCode, _id } = editData
    const { actionLoader } = useSelector((state) => state.relations);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        form.setFieldsValue({
            relationCode,
        })
    }, [open])

    const onFinish = async (values) => {

        const resultAction = await dispatch(editRelationType({ ...values, relationCodeId: _id }));
        if (editRelationType.fulfilled.match(resultAction)) {
            await dispatch(getRelationType({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("edit relation");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >

            <Form.Item
                name="relationCode"
                label="Relation "
                rules={[{ required: true, message: 'Please enter  relation name ' }]}
            >
                <Input placeholder='Enter Relation Name' />
            </Form.Item>

            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const editProps = {
        open,
        setOpen,
        title: 'Edit  Relation',
        action: 'Edit',
        content: AddForm,
        btnType: "link"

    };

    return (
        <section>
            <AddDrawer {...editProps} />
        </section>
    );
}


export default EditRelationType